import { TestProjectService } from '../services';
import {
    STORE_TEST_PROJECT,
    STORE_TEST_PROJECT_WIZARD,
    STORE_TEST_PROJECT_DASHBOARD,
    STORE_TEST_PROJECT_RUN_TOPIC_PREVIEW,
    STORE_TEST_PROJECT_TOPIC_WIZARD,
    STORE_TEST_PROJECT_RUN_COMPARE
} from './constants';
import { RootStores } from '../../common/stores';
import TestProjectsVisualStore from './TestProjectsVisualStore';
import { STORE_PROJECTS, STORE_PROJECTS_ROOT_UI, STORE_ROUTER, STORE_USERS } from '../../common/constants';
import { ProjectsService } from '../../common/services';
import TestProjectWizardStore from './TestProjectWizardStore';
import { RulesService } from '../../rules/services';
import TestProjectDashboardStore from './TestProjectDashboardStore';
import TestProjectRunTopicPreviewStore from './TestProjectRunTopicPreviewStore';
import TestProjectTopicWizardStore from './TestProjectTopicWizardStore';
import TestProjectRunCompareStore from './TestProjectRunCompareStore';
import { AdministrationService } from '../../project_management/services/AdministrationService';
export { default as TestProjectsVisualStore } from './TestProjectsVisualStore';
export { default as TestProjectWizardStore } from './TestProjectWizardStore';
export { default as TestProjectDashboardStore } from './TestProjectDashboardStore';
export { default as TestProjectTopicWizardStore } from './TestProjectTopicWizardStore';
export { default as TestProjectRunCompareStore } from './TestProjectRunCompareStore';

export function injectTestProjectStores(obj: RootStores) {
    const service = new TestProjectService();
    const projectsService = new ProjectsService();
    const rulesService = new RulesService();
    const adminService = new AdministrationService();

    obj[STORE_TEST_PROJECT] = new TestProjectsVisualStore(
        service,
        obj[STORE_PROJECTS_ROOT_UI],
        projectsService,
        obj[STORE_ROUTER],
        obj[STORE_PROJECTS],
        obj[STORE_USERS]
    );
    obj[STORE_TEST_PROJECT_WIZARD] = new TestProjectWizardStore(service, obj[STORE_TEST_PROJECT], rulesService);
    obj[STORE_TEST_PROJECT_DASHBOARD] = new TestProjectDashboardStore(
        obj[STORE_PROJECTS_ROOT_UI],
        obj[STORE_ROUTER],
        obj[STORE_TEST_PROJECT],
        service,
        adminService,
        obj[STORE_PROJECTS]
    );
    obj[STORE_TEST_PROJECT_RUN_TOPIC_PREVIEW] = new TestProjectRunTopicPreviewStore();
    obj[STORE_TEST_PROJECT_TOPIC_WIZARD] = new TestProjectTopicWizardStore(
        service,
        rulesService,
        obj[STORE_TEST_PROJECT_DASHBOARD]
    );
    obj[STORE_TEST_PROJECT_RUN_COMPARE] = new TestProjectRunCompareStore(
        obj[STORE_TEST_PROJECT_DASHBOARD],
        obj[STORE_ROUTER],
        service
    );
}

export type TestProjectStores = {
    [STORE_TEST_PROJECT]?: TestProjectsVisualStore;
    [STORE_TEST_PROJECT_WIZARD]?: TestProjectWizardStore;
    [STORE_TEST_PROJECT_DASHBOARD]?: TestProjectDashboardStore;
    [STORE_TEST_PROJECT_RUN_TOPIC_PREVIEW]?: TestProjectRunTopicPreviewStore;
    [STORE_TEST_PROJECT_TOPIC_WIZARD]?: TestProjectTopicWizardStore;
    [STORE_TEST_PROJECT_RUN_COMPARE]?: TestProjectRunCompareStore;
};
